import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import { i18n } from './i18n/index.js'

// import "amfe-flexible"
// 导入element
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import './styles/global.less'

import windowSizeMixin from '@/mixins/resize'

Vue.mixin(windowSizeMixin)

// 导入vant
import { Button } from 'vant'
Vue.use(ElementUI)
Vue.use(Button)
Vue.config.productionTip = false

// 防止sessionStorage修改
window.addEventListener('storage', function (e) {
  sessionStorage.setItem(e.key, e.oldValue)
})

const vueInstance = new Vue({
  router,
  i18n,
  store,
  render: (h) => h(App),
}).$mount('#app')

export default vueInstance
